import React from 'react';
import '../styles/DuatGame.css';

const DuatGame: React.FC = () => {
  return (
    <div className="duat-game-container">
      <h1>Duat Game</h1>
      <div className="game-content">
        <p>Game content will go here</p>
      </div>
    </div>
  );
};

export default DuatGame;